import notify from 'devextreme/ui/notify';
import { Component} from '@angular/core';

@Component({
    selector: 'app-dev-notify-bar',
    template: '',
    standalone: false
})
//TODO: delete this and calls to it. We have NotificationService for this and already are handling this logic in requestOptions.
export  class  AppDevNotifyComponent {
   public static SuccesMessage(msg: string) {
        notify(msg,  "success", 600);
    }
    public static ErrorMessage(msg: string) {
        notify(msg, "error", 600);
    }
}
